require([
],
function () {

    function initEventHandlers() {
        $(".product-description-tabs .title").off("click").on("click", changeTab);
    }

    function changeTab(event) {
        var contentSelector = $(this).data("content");
        var parentElement = $(this).closest(".product-description-tabs");

        $(parentElement).find(".title").removeClass("active");
        $(this).addClass("active");

        $(parentElement).find(".tab-content").removeClass("active");
        $(parentElement).find(".tab-content" + contentSelector).addClass("active");
    }

    initEventHandlers();

});

define("ProductDescriptionTabs/main", function(){});

